import { object, string, ref } from 'yup'

export const resetSchema = object({
    password: string().min(6, "A senha deve conter no mínimo 6 caracteres").required("Senha é obrigatório"),
    confirmPassword: string().oneOf([ref("password"), ""], "As senhas informadas devem ser iguais ").required("A confirmação é obrigatório"),

})